import React, {PureComponent} from 'react';
import {observer, inject} from 'mobx-react';
import _ from 'lodash';
import validate from 'validate.js';
import Dialog from 'material-ui/Dialog';
import HttpClient from 'services/HttpClient';
import {PageWrapper} from 'components/PageWrapper';
import SampleContentForm from '../components/Form';
import {SAMPLE_CONTENT_CONSTRAINS} from 'constants/adminPupups';

const sampleContentUrl = '/api/v1/free_samples/';

@inject('sampleContentStore')
@inject('alertStore')
@observer
class EditSampleContent extends PureComponent {
  constructor() {
    super();

    this.state = {
      isConfirmModalOpened: false,
    };
  }

  componentDidMount() {
    const {match, sampleContentStore: {setSampleContent}} = this.props;
    const id = match.params.id;

    if(id) {
      new HttpClient().get(`${sampleContentUrl}${id}`).then(data => {
        const sampleContent = {
          ...data.body.data.free_sample,
          sample_type: data.body.data.free_sample.sample_type === 'video' ? 0 : 1,
          file: {
            file_url: data.body.data.free_sample.file_url
          }
        };

        setSampleContent(sampleContent);
      }).catch(() => {
        this.props.alertStore.success('Something went wrong');
      });
    }
  }

  handleChange = e => {
    const {sampleContentStore} = this.props;

    if (e.target.name === 'file') {
      sampleContentStore.handleChange({[e.target.name]: e.target.files[0]});
    } else {
      sampleContentStore.handleChange({[e.target.name]: e.target.value});
    }
  };

  validationProcess = sampleContent => {
    let errors = validate(sampleContent, SAMPLE_CONTENT_CONSTRAINS, { fullMessages: false });

    return errors
  };

  submit = e => {
    e.preventDefault();

    const {sampleContentStore, match} = this.props;
    const id = match.params.id;
    const sampleContent = _.assign({}, sampleContentStore.sampleContent);
    const errors = this.validationProcess(sampleContent);

    sampleContentStore.setError(errors);

    if (errors) {
      return;
    }

    const formData = new FormData();
    formData.append('title', sampleContent.title);
    formData.append('sample_type', sampleContent.sample_type);
    if (sampleContent.file.name)
      formData.append('file', sampleContent.file, sampleContent.file.name);
    if (sampleContent.video_url)
      formData.append('video_url', sampleContent.video_url);

    new HttpClient().multipart(`${sampleContentUrl}${id}`, formData, 'PUT').then(data => {
      sampleContentStore.saveSampleContent(data.body.data.free_sample);
      this.props.alertStore.success('You successfully edited sample content');
      this.props.history.push('/sample-content');
      
    }).catch(() => {
      this.props.alertStore.success('Something went wrong');
    });
  };

  deleteSampleContent = () => {
    const { alertStore, history, match, sampleContentStore } = this.props;
    const sampleContent = sampleContentStore.sampleContent;

    new HttpClient().delete(`${sampleContentUrl}${sampleContent.id}`)
    .then(() => {
      alertStore.success(`You successfully delete sample ${sampleContent.sample_type === 0 ? 'video' : 'OSCE'}`);
      history.push('/sample-content');
    });
  };

  handleOpenConfirmModal = () => {
    this.setState({
      isConfirmModalOpened: true,
    });
  };

  handleCloseConfirmModal = () => {
    this.setState({
      isConfirmModalOpened: false,
    });
  };

  render() {
    const { sampleContentStore } = this.props;
    const sampleContent = sampleContentStore.sampleContent;
    const { isConfirmModalOpened } = this.state;

    return (
      <PageWrapper>
        <button onClick={this.handleOpenConfirmModal} className='delete-btn'>delete {sampleContent.sample_type === 0 ? 'video' : 'OSCE'}</button>
        <SampleContentForm submit={this.submit} />
        <Dialog
          className="modal-wrapper category-handle"
          title={`Are you sure you want to delete this ${sampleContent.sample_type === 0 ? 'video' : 'OSCE'}?`}
          modal={true}
          open={isConfirmModalOpened}
          customContentStyle={{
            height: '100%',
            maxHeight: 'none',
          }}
          bodyClassName="modal-content"
          repositionOnUpdate={true}
          autoDetectWindowHeight={true}
          autoScrollBodyContent={false}>
          <div className="button-set">
            <button
              className="btn gray small transparanted cancel-btn"
              type="reset"
              onClick={this.handleCloseConfirmModal}
            >
              No
            </button>
            <button
              className="btn gray small transparanted apply-btn"
              type="submit"
              onClick={this.deleteSampleContent}
            >
              Yes
            </button>
          </div>
        </Dialog>
      </PageWrapper>
    );
  }
}

export default EditSampleContent;



// WEBPACK FOOTER //
// ./src/modules/admin/sampleContent/containers/Edit.js